// src/components/LanguageSelector.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import {Dropdown} from "react-bootstrap";

const LanguageSelector = () => {
    const { i18n } = useTranslation();

    const handleChange = (lng) => {
        try { localStorage.setItem('appLanguage', lng); } catch (e) {}
        i18n.changeLanguage(lng);
    };

    const flagStyle = {
        width: 18,
        height: 12,
        objectFit: 'cover',
        marginRight: 8,
        display: 'inline-block',
        verticalAlign: 'middle',
        borderRadius: 2
    };

    // Helper function to get language display
    const getLanguageDisplay = () => {
        switch(i18n.language) {
            case 'en':
                return { flag: '/assets/images/languages/us.png', label: 'English (EN)' };
            case 'cn':
                return { flag: '/assets/images/languages/cn.png', label: ' 中国人 (CN)' };
            case 'de':
                return { flag: '/assets/images/languages/de.png', label: 'Deutsch (DE)' };
            case 'ja':
                return { flag: '/assets/images/languages/ja.png', label: '日本語 (JP)' };
            case 'kr':
                return { flag: '/assets/images/languages/kr.png', label: '한국인 (KR)' };
            case 'fr':
                return { flag: '/assets/images/languages/fr.png', label: 'Français (FR)' };
            case 'es':
                return { flag: '/assets/images/languages/es.png', label: 'Español (ES)' };
            // case 'bn':
            //     return { flag: '/assets/images/languages/bn.png', label: 'বাংলা (BN)' };
            // case 'sa':
            //     return { flag: '/assets/images/languages/sa.png', label: 'عربي (SA)' };
            // case 'my':
            //     return { flag: '/assets/images/languages/my.png', label: 'Malaysian (MY)' };
            // case 'sg':
            //     return { flag: '/assets/images/languages/sg.png', label: 'Singaporean (SG)' };
            // case 'tw':
            //     return { flag: '/assets/images/languages/tw.png', label: 'Taiwanese (TW)' };
            default:
                return { flag: '/assets/images/languages/us.png', label: 'English (EN)' };
        }
    };

    const currentLanguage = getLanguageDisplay();

    return (
        <ul className="list-unstyled list-inline bar-lang">
            <li className="list-inline-item">
                {/* Dropdown for Language Selection */}
                <Dropdown>
                    <Dropdown.Toggle>
                        {/* Dynamically update based on selected language */}
                        <img style={flagStyle} src={process.env.PUBLIC_URL + currentLanguage.flag} alt="" />
                        {currentLanguage.label}
                        <i className="las la-angle-down" style={{ marginLeft: 6 }}></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu as="ul">
                        <Dropdown.Item as="li" onClick={() => handleChange('en')}>
                            <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/us.png"} alt="" /> English (EN)
                        </Dropdown.Item>
                        <Dropdown.Item as="li" onClick={() => handleChange('cn')}>
                            <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/cn.png"} alt="" /> 中国人 (CN)
                        </Dropdown.Item>
                        <Dropdown.Item as="li" onClick={() => handleChange('de')}>
                            <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/de.png"} alt="" /> Deutsch (DE)
                        </Dropdown.Item>
                        <Dropdown.Item as="li" onClick={() => handleChange('ja')}>
                            <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/ja.png"} alt="" /> 日本語 (JP)
                        </Dropdown.Item>
                        <Dropdown.Item as="li" onClick={() => handleChange('kr')}>
                            <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/kr.png"} alt="" /> 한국인 (KR)
                        </Dropdown.Item>
                        <Dropdown.Item as="li" onClick={() => handleChange('fr')}>
                            <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/fr.png"} alt="" /> Français (FR)
                        </Dropdown.Item>
                        <Dropdown.Item as="li" onClick={() => handleChange('es')}>
                            <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/es.png"} alt="" /> Español (ES)
                        </Dropdown.Item>
                        {/*<Dropdown.Item as="li" onClick={() => handleChange('bn')}>*/}
                        {/*    <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/bn.png"} alt="" /> বাংলা (BN)*/}
                        {/*</Dropdown.Item>*/}
                        {/*<Dropdown.Item as="li" onClick={() => handleChange('sa')}>*/}
                        {/*    <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/sa.png"} alt="" />   عربي (SA)*/}
                        {/*</Dropdown.Item>*/}
                        {/*<Dropdown.Item as="li" onClick={() => handleChange('my')}>*/}
                        {/*    <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/my.png"} alt="" /> Malaysian (MY)*/}
                        {/*</Dropdown.Item>*/}
                        {/*<Dropdown.Item as="li" onClick={() => handleChange('sg')}>*/}
                        {/*    <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/sg.png"} alt="" /> Singaporean (SG)*/}
                        {/*</Dropdown.Item>*/}
                        {/*<Dropdown.Item as="li" onClick={() => handleChange('tw')}>*/}
                        {/*    <img style={flagStyle} src={process.env.PUBLIC_URL + "/assets/images/languages/tw.png"} alt="" /> Taiwanese (TW)*/}
                        {/*</Dropdown.Item>*/}
                    </Dropdown.Menu>
                </Dropdown>
            </li>
        </ul>
    );
};

export default LanguageSelector;